<template>
  <app-standard-modal
    :open="open"
    title="Quote Totals"
    title-id="quote-totals-modal-title"
    size="small"
    :scrolling="false"
    append-to-body
    @close="$emit('close')"
  >
    <div class="quote-pricing-modal-body">
      <div class="ui grid quote-pricing-modal-grid">
        <div class="right aligned nine wide column quote-pricing-labels-col">
          <div class="quote-pricing-detail-label">Labour time</div>
          <div class="quote-pricing-detail-label">Product Cost</div>
          <div class="quote-pricing-detail-label quote-pricing-detail-label--section-end">Gross Profit</div>
          <div
            class="quote-pricing-detail-label"
            v-if="showCalloutFee"
          >Callout Fee</div>
          <div class="quote-pricing-detail-label">Discount</div>
          <div class="quote-pricing-detail-label">Subtotal</div>
          <div class="quote-pricing-detail-label">Total GST</div>
        </div>

        <div class="right aligned six wide column quote-pricing-values-col">
          <div class="quote-pricing-detail-value">{{ labourTimeDisplay }}</div>
          <div class="quote-pricing-detail-value">{{ formatCurrency(margin.cost_total) }}</div>
          <div class="quote-pricing-detail-value quote-pricing-detail-value--section-end">{{ formatCurrency(margin.gross_profit) }}</div>
          <div
            class="quote-pricing-detail-value"
            v-if="showCalloutFee"
          >{{ formatCurrency(quote.callout_fee) }}</div>
          <div class="quote-pricing-detail-value">{{ formatCurrency(quote.discount) }}</div>
          <div class="quote-pricing-detail-value">{{ formatCurrency(quote.sub_total) }}</div>
          <div class="quote-pricing-detail-value">{{ formatCurrency(quote.gst_total) }}</div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="ui primary button" @click="$emit('close')">OK</div>
    </template>
  </app-standard-modal>
</template>

<script>
import { calculateQuoteMargin } from '../../../helpers/quoteMargin'

export default {
  name: 'QuoteTotalsModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    quote: {
      type: Object,
      default: function () { return {} }
    },
    quoteItems: {
      type: Array,
      default: function () { return [] }
    }
  },
  computed: {
    margin: function () {
      const q = this.quote || {}
      return calculateQuoteMargin(q, this.quoteItems || [], q.discount)
    },
    showCalloutFee: function () {
      const account = this.$store.getters['setting/getAccount'] || {}
      return account.price_structure === 1 && this.quote && Number(this.quote.callout_fee) > 0
    },
    labourTimeDisplay: function () {
      const q = this.quote || {}
      const hours = q.labour_time_hours != null ? q.labour_time_hours : 0
      const minutes = q.labour_time_minutes != null ? q.labour_time_minutes : 0
      return hours + 'hr ' + minutes + 'min'
    }
  },
  methods: {
    formatCurrency: function (value) {
      if (typeof this.currency === 'function') {
        return this.currency(value, '$', 2, { decimalSeperator: ',' })
      }
      const n = Number(value)
      if (!Number.isFinite(n)) return '$0.00'
      return '$' + n.toFixed(2)
    }
  }
}
</script>
